export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";

// Action to enable/disable to loading indicator
export function setLoading(isLoading) {
  return isLoading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" };
}

export const setMoreStories = (payload) => {
  return {
    type: "MORE_STORIES",
    payload
  };
};

export const setStoryTemplate = (payload) => {
  return {
    type: "STORY_TEMPLATE",
    payload
  };
};

export const setLatestTenStoriesAction = (stories) => {
  return {
    type: "SET_LATEST_TEN_STORIES",
    payload: stories
  };
};

export const setLatestSectionStoriesAction = (stories) => {
  return {
    type: "SET_LATEST_SECTION_STORIES",
    payload: stories
  };
};

export const setMakeSecondaryApiCallsTriggered = (makeSecondaryApiCalls, delay) => {
  return {
    type: "SET_MAKE_SECONDARY_API_CALLS_TRIGGERED",
    makeSecondaryApiCalls: makeSecondaryApiCalls,
    delay: delay
  };
};
export const setIsStickyBannerVisible = (payload) => {
  return {
    type: "SET_IS_STICKY_BANNER_VISIBLE",
    payload
  };
};
